export default __webpack_public_path__ + "static/media/BusHeartMarker.cdaa6035.png";